import { Transform } from 'class-transformer';
import { dateTransform } from '../utils/helper';

export class Note {
    id!: number;
    actorid!: number;
    note!: string;
    writerid?: number;
    entity!: string;
    @Transform(dateTransform)
    insdate?: Date;
    @Transform(dateTransform)
    moddate?: Date;
}